import CameraIcon from "assets/icons/camera.svg";

import styles from "./map-phoyo-marker-context-menu.module.scss";
interface MapPhotoMarkerContextMenuInterface {
  photoSrc: string;
}

const MapPhotoMarkerContextMenu = ({
  photoSrc
}: MapPhotoMarkerContextMenuInterface) => {
  return (
    <div className={styles["context-menu-container"]}>
      <a
        href={photoSrc}
        target="_blank"
        className={styles["option"]}
        rel="noreferrer"
      >
        <div className={styles["option-icon"]}>
          <img src={CameraIcon} alt="camera" />
        </div>
        Download full photo
      </a>
    </div>
  );
};

export default MapPhotoMarkerContextMenu;
